var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#da1884;stroke-linejoin:round;stroke-width:4.17px;}")),React.createElement("circle",{"className":"cls-1","cx":"47.39","cy":"47.39","r":"43.33","key":1}),React.createElement("polygon",{"className":"cls-1","points":"50.43 54.91 44.35 54.91 42.35 18.93 52.43 18.93 50.43 54.91","key":2}),React.createElement("circle",{"className":"cls-1","cx":"47.39","cy":"68.25","r":"5.69","key":3})]);
}

Warning.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 94.77 94.77"};

module.exports = Warning;

Warning.default = Warning;
